import { ContactConfig } from '../../contact.types';

const APPLICATIONS = [
  'Ansible Tower',
  'Atlassian',
  'Bonnie',
  'CDAC MedTrak',
  'Cloudbee Jenkins',
  'CyberArk',
  'DARRT',
  'MFT',
  'DEL',
  'FileCloud',
  'FIVS',
  'GitHub',
  'GitHub Cloud',
  'QualityNet Workspace',
  'QualityNet Operation Dashboard',
  'MAT',
  'New Relic',
  'QBIC',
  'QMARS',
  'Qualtrics',
  'QuickSight',
  'QTSO',
  'SAS Viya',
  'Survey Certification and CLIA Budget System',
  'Slack',
  'ServiceNow',
  'Splunk',
  'SurveyMonkey',
  'TestRail',
  'Zscaler',
];

APPLICATIONS.sort();

APPLICATIONS.splice(-1, 1, `and ${APPLICATIONS[APPLICATIONS.length - 1]}`);

export default {
  headerText: `For help with ${APPLICATIONS.join(', ')},
  contact the Service Center through the contact information below.
  `,
  links: [
    {
      label: 'Check out HARP Help for more info',
      routerLink: '/help',
    },
  ],
  contactDetails: {
    hours: 'Available 24/7',
    days: 'Monday - Friday',
    email: 'ServiceCenterSOS@cms.hhs.gov',
    phone1: '1-866-288-8914',
    slack: '#help-service-center-sos',
  },
} as ContactConfig;
